<div id="currentInformation" class="control-container">
    <loading-animation size="large" *ngIf="!isLoaded"></loading-animation>
    <div *ngIf="isLoaded">
        <div>
            <cas-header [primary]="currentControl.text" [contrast]="modelName"></cas-header>
            <div class="currentInformation-buttons">
                <cas-button btnClass="md-raised md-accent" materialIcon="save" [disabled]="(!currentInfoForm.dirty || currentInfoForm.invalid) && !templateApplied" (clickAction)="updateCurrentInfoEx()" btnText="Save"></cas-button>
                <cas-button btnClass="md-raised md-accent" materialIcon="cancel" btnText="Cancel" (clickAction)="this.cancelChanges();"></cas-button>

                <cas-button btnClass="md-raised md-accent" *ngIf="canManageTemplates" [disabled]="false" (clickAction)="selectTemplate()" btnText="Apply Template"></cas-button>
                <cas-button btnClass="md-raised md-accent" *ngIf="canManageTemplates" [disabled]="false" (clickAction)="makeTemplate()" btnText="Create Template"></cas-button>

                <cas-button btnClass="md-raised md-accent" *ngIf="hasCAALManagementPermission && isCommissionerModelSupported && canImportFromCAALFile" [disabled]="false" (clickAction)="onImportFromCAALFileClick()" btnText="Import From CAAL File"></cas-button>
            </div>
            </div>
            <dl-device-grouping
                class="deviceInfo"
                [grouping]="deviceInformation"
                [deviceInputForm]="currentInfoForm"
                [setDeviceInfo]="setDeviceInfo"
            >
            </dl-device-grouping>
        </div>
    </div>
